import { Input } from "antd";
import { Control, Controller } from "react-hook-form";
import { LockOutlined } from "@ant-design/icons";

interface IProps {
  name: string;
  placeholder: string;
  control: Control<any, any>;
  label: string;
}

export default function LabeledPasswordInput({
  name,
  label,
  placeholder,
  control,
}: IProps) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <div className="w-full">
          <label
            htmlFor={name}
            className="pl-1"
            style={{ color: "rgba(0,0,0,.7)", fontSize: ".85rem" }}
          >
            {label}
          </label>

          <Input.Password
            {...field}
            status={error ? "error" : undefined}
            size="large"
            className="outline-none"
            placeholder={placeholder}
            prefix={<LockOutlined />}
          />
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
